import React from "react";
import { useNavigate } from "react-router-dom";

const NonProvider = () => {
  const navigate = useNavigate();
  return (
    <div className="text-center">
      <h5 className="text-center mt-3 mb-5">
        <p className="text-center fs-6 fw-bold lead">
          To make an offer, please first list your service.
        </p>{" "}
        <br />
        <p style={{ fontWeight: "bold", fontSize: "18px", color: "red" }}>
          Go to Dashboard &gt; Services for Sale &gt; Add New
        </p>{" "}
        <br />
        <p className="text-center fs-6 fw-bold lead">
          This will allow the buyer to see who is making the offer.
        </p>
      </h5>
      <div class="d-flex justify-content-end">
        <button
          className="btn btn-primary px-4"
          style={{ marginRight: "20px" }}
          onClick={() => navigate("/create-service")}
        >
          Ok
        </button>
      </div>
    </div>
  );
};

export default NonProvider;
